
    import { Component,  Vue } from 'vue-property-decorator';
    import { ITag } from '@/interfaces/Tags/ITag';
    import { IFileTags } from '@/interfaces/Files/IFileTags';
    import tagsAPI from '@/store/tagsAPI';
    import filesAPI from '@/store/filesAPI';
    import Multiselect from 'vue-multiselect'
    @Component({
        components: {
            Multiselect
        }
    })    
    export default class AddFile extends Vue {
        private errors = {} as { [id: string]: any };
        private saveErrors = "";
        private filename:string = "";
        private heading:string = "Add File"
        private TagTypeSelected = [] as Array<ITag>;
        private TagTypeSelectededit = [] as Array<ITag>;

        private drpbiome = [] as Array<ITag>;
        private drpenv = [] as Array<ITag>;
        private drpnooftaxa = [] as Array<ITag>;
        private drpnooflinks = [] as Array<ITag>;
        private drpcontinent = [] as Array<ITag>;
        private drpdominant = [] as Array<ITag>;
        private drpincludeparasite = [] as Array<ITag>;
        private drpyearofcollection = [] as Array<ITag>;
        private drptaxonomic = [] as Array<ITag>;
        
        private formValues = {
            file: null,
            selectedbiome: [],
            selectedenv: [],
            selectednooftaxa: [],
            selectednooflinks: [],
            selectedcontinent: [],
            selecteddominant: [],
            selectedincludeparasite: [],
            selectedyearofcollection: [],
            selectedtaxonomic: []
        } as { [id: string]: any }

        private async register() {
            this.TagTypeSelected = this.formValues.selectedbiome
                .concat(this.formValues.selectedenv)
                .concat(this.formValues.selectednooftaxa)
                .concat(this.formValues.selectednooflinks)
                .concat(this.formValues.selectedcontinent)
                .concat(this.formValues.selecteddominant)
                .concat(this.formValues.selectedincludeparasite)
                .concat(this.formValues.selectedyearofcollection)
                .concat(this.formValues.selectedtaxonomic)   
            console.log(this.TagTypeSelected);
            try {
                let errors:boolean = false;
                if (this.formValues.file == null && this.filename=="") {
                    alert("This is a required field, please choose a file")
                   // this.saveErrors = "This is a required field, please choose a file";
                    errors = true;
                }
                else if (this.TagTypeSelected.length <= 0) {
                      alert("Please select atleast one tag ")
                    //this.saveErrors = "Please select atleast one tag";
                    errors = true;
                }

                if (!errors) {
                    if (this.$route.params.fileId != undefined) {
                        console.log("edit")
                        //for removig tags
                        const aTagTypeSelected = this.TagTypeSelected;
                        let removeTagTypeSelected = [] as Array<ITag>;                       
                        this.TagTypeSelectededit.forEach(function (item: ITag) {
                            let foundr = aTagTypeSelected.some(key => key.id === item.id);
                            if (!foundr)
                                removeTagTypeSelected.push(item);

                        });
                        //for inserting tags
                        const aTagTypeSelectededit = this.TagTypeSelectededit;
                         let insertTagTypeSelected = [] as Array<ITag>;
                        this.TagTypeSelected.forEach(function (item: ITag) {
                            let foundi = aTagTypeSelectededit.some(key => key.id === item.id);
                            if (!foundi)
                                insertTagTypeSelected.push(item);
                        });
                        let formData: FormData = new FormData();
                        //if file is null then it won't edit file it will keep th old file
                        formData.append('file', this.formValues.file);                      
                        formData.append('removeTagType', JSON.stringify(removeTagTypeSelected));
                        formData.append('insertTagType', JSON.stringify(insertTagTypeSelected));
                    //    formData.append('removeTagType', removeTagTypeSelected);
                    //    formData.append('insertTagType', insertTagTypeSelected);

                        formData.append('fileId', this.$route.params.fileId);
                       // console.log(formData)
                        await filesAPI.editfile(formData)
                       // await filesAPI.editfile(this.formValues.file, removeTagTypeSelected, insertTagTypeSelected, this.$route.params.fileId)
                        alert("Editted Successfully");
                        this.$router.push({ path: "/files" });
                    }
                    else {
                        console.log("success")                      
                        let formData: FormData = new FormData();
                        formData.append('file', this.formValues.file);
                        formData.append('tags', JSON.stringify(this.TagTypeSelected));
                        console.log(formData)
                        await filesAPI.postfile(formData)
                        alert("Added Successfully");
                        this.$router.push({ path: "/files" });
                }
                }                
            }
            catch (error) {
                   // this.saveErrors="Error while adding the file. If the issue persists, please contact us.";
                } finally {
                    // this.saving = false;
           }
           
        }
        private selectedvalue(result: IFileTags) {
            this.filename = result.file.fileName;
            this.TagTypeSelected = result.tags;
            this.TagTypeSelectededit = result.tags;
            if (this.TagTypeSelected != null && this.TagTypeSelected.length > 0)
            {                
                const selectbiomeedit = [] as Array<ITag>;
                const selectedenvedit = [] as Array<ITag>;
                const selectednooftaxaedit = [] as Array<ITag>;
                const selectednooflinksedit = [] as Array<ITag>;
                const selectedcontinentedit = [] as Array<ITag>;
                const selecteddominantedit = [] as Array<ITag>;
                const selectedincludeparasiteedit = [] as Array<ITag>;
                const selectedyearofcollectionedit = [] as Array<ITag>;
                const selectedtaxonomicedit = [] as Array<ITag>;
                this.TagTypeSelected.forEach(function (item: ITag) {
                    if (item.tagTypeId == 21) 
                        selectbiomeedit.push(item);
                    else if (item.tagTypeId == 22) 
                        selectedenvedit.push(item);
                    else if (item.tagTypeId == 23) 
                        selectednooftaxaedit.push(item);
                    else if (item.tagTypeId == 24)
                        selectednooflinksedit.push(item);
                    else if (item.tagTypeId == 25)
                        selectedcontinentedit.push(item);
                    else if (item.tagTypeId == 26)
                        selecteddominantedit.push(item);
                    else if (item.tagTypeId == 27)
                        selectedincludeparasiteedit.push(item);
                    else if (item.tagTypeId == 28)
                        selectedyearofcollectionedit.push(item);
                    else if (item.tagTypeId == 29)
                        selectedtaxonomicedit.push(item);
                });
                this.formValues.selectedbiome = selectbiomeedit;
                this.formValues.selectedenv = selectedenvedit;
                this.formValues.selectednooftaxa = selectednooftaxaedit;
                this.formValues.selectednooflinks = selectednooflinksedit;
                this.formValues.selectedcontinent = selectedcontinentedit;
                this.formValues.selecteddominant = selecteddominantedit;
                this.formValues.selectedincludeparasite = selectedincludeparasiteedit;
                this.formValues.selectedyearofcollection = selectedyearofcollectionedit;
                this.formValues.selectedtaxonomic = selectedtaxonomicedit;
            }

        }
        private async mounted() {
            if (this.$route.params.fileId != undefined) {
                this.heading = "Edit File";
                await filesAPI.getfilebyid(Number(this.$route.params.fileId)).then((result:any) => { this.selectedvalue(result); });
            }
            this.drpbiome = await tagsAPI.getTags(21);
            this.drpenv = await tagsAPI.getTags(22);
            this.drpnooftaxa = await tagsAPI.getTags(23);
            this.drpnooflinks = await tagsAPI.getTags(24);
            this.drpcontinent = await tagsAPI.getTags(25);
            this.drpdominant = await tagsAPI.getTags(26);
            this.drpincludeparasite = await tagsAPI.getTags(27);
            this.drpyearofcollection = await tagsAPI.getTags(28);
            this.drptaxonomic = await tagsAPI.getTags(29);
        }
        }
